import styled from '@common/theme/styled-components';

export const DummyLink = styled.div``;
